export enum ProxyMode {
  WITH = 'with',
  WITHOUT = 'without',
}

export type ShipmentsQueryParams = {
  shipmentNumber?: string
  query?: string
  country?: string
  email?: string
  phone?: string
  customer?: string
  statuses?: string
  carriers?: string
  dateFrom?: string
  dateTo?: string
  checkedIn?: string
  returnAssignments?: string
  packagesDivertedToServicePoint?: string
  withServicePointCollectingProblem?: string
  withRecipientNotificationProblem?: string
  distributionChannel?: string
  proxyMode?: string
}

export type ShipmentEventsListQueryParams = {
  item?: string[]
  dateFrom?: string
  dateTo?: string
  senderType?: string
}

export type AuditLogQueryParams = {
  entityType?: string
  userId?: string
  dateFrom?: string
  dateTo?: string
}
